import { render, staticRenderFns } from "./AddMessageContents.vue?vue&type=template&id=56e080d8&scoped=true"
import script from "./AddMessageContents.vue?vue&type=script&lang=js"
export * from "./AddMessageContents.vue?vue&type=script&lang=js"
import style0 from "./AddMessageContents.vue?vue&type=style&index=0&id=56e080d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e080d8",
  null
  
)

export default component.exports